{
  "alert": "Hälytys",
  "dismiss": "Hylkää"
}
